<template>
    <figure class="highlight" v-highlight>
        <slot></slot>
    </figure>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" type="text/less">
.highlight {
  border: 1px solid #eee;
}
</style>




// WEBPACK FOOTER //
// highlight.vue?3989d0ba